export default __webpack_public_path__ + "static/media/second.c4ef557f.png";